import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrlFico } from "../../../contexts/ContextProvider";
import { ShowTableNeracaSaldo } from "../../../components/ShowTable";
import { Loader } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { Box, Typography, ButtonGroup, Button } from "@mui/material";
import { Container, Form } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";

const NeracaSaldo = () => {
  const { user, dispatch } = useContext(AuthContext);
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);

  const [validated, setValidated] = useState(false);
  const [isFetchError, setIsFetchError] = useState(false);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [neracaSaldos, setNeracaSaldosData] = useState([]);
  const [totalDebet, setTotalDebet] = useState(0);
  const [totalKredit, setTotalKredit] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // getNeracaSaldosData();
  }, []);

  const getNeracaSaldosData = async () => {
    let tempTotalDebet = 0;
    let tempTotalKredit = 0;
    setLoading(true);
    try {
      const neracaSaldos = await axios.post(
        `${tempUrlFico}/neracaSaldoPeriode`,
        {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setNeracaSaldosData(neracaSaldos.data);
      for (let i = 0; i < neracaSaldos.data.length; i++) {
        tempTotalDebet += neracaSaldos.data[i].debet;
        tempTotalKredit += neracaSaldos.data[i].kredit;
      }
      setTotalDebet(tempTotalDebet);
      setTotalKredit(tempTotalKredit);
      setPreviewPdf(true);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    const form = e.currentTarget;
    let tempTotalDebet = 0;
    let tempTotalKredit = 0;
    if (form.checkValidity()) {
      const neracaSaldos = await axios.post(
        `${tempUrlFico}/neracaSaldoPeriode`,
        {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setNeracaSaldosData(neracaSaldos.data);
      for (let i = 0; i < neracaSaldos.data.length; i++) {
        tempTotalDebet += neracaSaldos.data[i].debet;
        tempTotalKredit += neracaSaldos.data[i].kredit;
      }
      setTotalDebet(tempTotalDebet);
      setTotalKredit(tempTotalKredit);
      setPreviewPdf(!previewPdf);
    } else {
      // setError(true);
      // setOpen(!open);
    }
    setValidated(true);
    setLoading(false);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "NeracaSaldo",
  });

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "NeracaSaldo",
    sheet: "NeracaSaldo",
  });

  const list = [];

  for (let j = 0; j < neracaSaldos.length; j++) {
    list.push(
      <tr>
        <td style={{ border: "1px solid black" }}>{neracaSaldos[j].kodeCOA}</td>
        <td style={{ border: "1px solid black" }}>{neracaSaldos[j].namaCOA}</td>
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {isCetakExcel === false
            ? parseInt(neracaSaldos[j].saldoAwal).toLocaleString("de-DE")
            : parseInt(neracaSaldos[j].saldoAwal)}
        </td>
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {isCetakExcel === false
            ? parseInt(neracaSaldos[j].debet).toLocaleString("de-DE")
            : parseInt(neracaSaldos[j].debet)}
        </td>
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {isCetakExcel === false
            ? parseInt(neracaSaldos[j].kredit).toLocaleString("de-DE")
            : parseInt(neracaSaldos[j].kredit)}
        </td>
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {isCetakExcel === false
            ? parseInt(neracaSaldos[j].saldoAkhir).toLocaleString("de-DE")
            : parseInt(neracaSaldos[j].saldoAkhir)}
        </td>
      </tr>
    );
  }
  list.push(
    <tr>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}>Balance :</td>
      <td style={{ border: "1px solid black", textAlign: "right" }}>
        {isCetakExcel === false
          ? parseInt(totalDebet).toLocaleString("de-DE")
          : parseInt(totalDebet)}
      </td>
      <td style={{ border: "1px solid black", textAlign: "right" }}>
        {isCetakExcel === false
          ? parseInt(totalKredit).toLocaleString("de-DE")
          : parseInt(totalKredit)}
      </td>
      <td style={{ border: "1px solid black" }}></td>
    </tr>
  );
  list.push(
    <tr>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}>Selisih :</td>
      {isCetakExcel === false ? (
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {totalDebet - totalKredit > 1 || totalDebet - totalKredit < -1
            ? (totalDebet - totalKredit).toLocaleString("de-DE")
            : 0}
        </td>
      ) : (
        <td style={{ border: "1px solid black", textAlign: "right" }}>
          {totalDebet - totalKredit > 1 || totalDebet - totalKredit < -1
            ? totalDebet - totalKredit
            : 0}
        </td>
      )}
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
    </tr>
  );

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Accounting</h3>
      <h5 style={{ fontWeight: 400 }}>Neraca Saldo</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />

      <Form noValidate validated={validated} onSubmit={tampilPdf}>
        <Box sx={spacingTop}>
          <Button variant="contained" startIcon={<PrintIcon />} type="submit">
            TAMPIL NERACA SALDO
          </Button>
        </Box>
      </Form>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>Neraca Saldo</p>
          <p>Periode : {user.tutupperiode.namaPeriode}</p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>Kode</th>
                <th style={{ border: "1px solid black" }}>Nama Rekening</th>
                <th style={{ border: "1px solid black" }}>Saldo Awal</th>
                <th style={{ border: "1px solid black" }}>Debet</th>
                <th style={{ border: "1px solid black" }}>Kredit</th>
                <th style={{ border: "1px solid black" }}>Saldo Akhir</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
          {/* <Box sx={tableContainer}>
          <ShowTableNeracaSaldo
            currentPosts={neracaSaldos}
            totalDebet={totalDebet}
            totalKredit={totalKredit}
            isCetakExcel={isCetakExcel}
            tableRef={tableRef}
          />
        </Box> */}
        </div>
      </div>
    </Container>
  );
};

export default NeracaSaldo;

const subTitleText = {
  fontWeight: "900",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const spacingTop = {
  mt: 4,
};
